<div *ngIf="isPreviewVisible && _quizData && _quizData.questions.length === 0" class="empty-quiz-preview">
  <div class="content">
    <h2 class="title">Quiz Questions (0 Questions)</h2>
    <div class="plus-icon">+</div>
    <p class="subtitle">No questions added</p>
    <p class="description"> Start by adding manual questions or generating with AI</p>
  </div>
</div>

<div *ngIf="isPreviewVisible &&  _quizData &&_quizData.questions.length > 0" class="quiz-preview-container">
  <h2 class="preview-title">Quiz Questions ({{ _quizData.questions.length }} Questions)</h2>
   <ng-container *ngFor="let quizQuestion of _quizData?.questions; let i = index">
  <div class="question-card">
    <div class="question-header">
      <span class="question-label">Q {{ i + 1 }}</span>
      <span class="question-type">{{ quizQuestion.question_type }}</span>
      <span class="question-points">{{ quizQuestion.marks }} pt</span>
    </div>
    <p class="question-text">{{ quizQuestion.question_text }}</p>
    <div *ngIf="quizQuestion.diagram_url || quizQuestion.diagram_payload" class="mt-2 text-start">
      <img [src]="quizQuestion.diagram_url || quizQuestion.diagram_payload" alt="Question Image" class="img-fluid rounded" style="max-height: 200px;">
    </div>
    <ul class="options-list" *ngIf="quizQuestion.question_type === 'MCQ'">
      <li *ngFor="let option of quizQuestion.options; let j = index"
        [class.correct]="option.text === quizQuestion.correct_answer">
        {{ getOptionLabel(j) }} . {{ option.text }}
      </li>
    </ul>
 
	<ul class="options-list" *ngIf="quizQuestion.question_type === 'TRUE_FALSE'">
  <li [class.correct]="quizQuestion.correct_answer.toString().toLowerCase() === 'true'">A. True</li>
  <li [class.correct]="quizQuestion.correct_answer.toString().toLowerCase() === 'false'">B. False</li>
</ul>
  </div>

  <div class="question-card" *ngIf="quizQuestion.question_type === 'OPEN_ENDED' ">
    <div class="open-ended-answer">
      <span class="key-answer-label">Key Answer: {{ quizQuestion.correct_answer }}
      </span>
    </div>
  </div>
  </ng-container>
</div>